enum SSOProvider {
    Google = "Google",
    Facebook = "Facebook",
}

export { SSOProvider }